export default {
  discount_badge: '{{value}} de descuento',
  high_caffeine_warning_required: 'Alto en cafeína',
  pfand: 'Incl. {{value}} de depósito',
  alcohol_by_volume_percent: '{{value}} % Vol. Alcohol',
};
